import script from "./recruitWillAuditApplyDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./recruitWillAuditApplyDetail.vue?vue&type=script&lang=ts&setup=true"

import "./recruitWillAuditApplyDetail.vue?vue&type=style&index=0&id=01fcf1de&lang=less"

const __exports__ = script;

export default __exports__